import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import OlistHeader from '../../components/custom/OlistHeader/OlistHeader';
import OlistFeatureGrid from '../../components/custom/OlistFeatureGrid/OlistFeatureGrid';
import OlistPricing from '../../components/custom/OlistPricing/OlistPricing';
import OlistFAQ from '../../components/custom/OlistFAQ/OlistFAQ';
import OlistFinalCTA from '../../components/custom/OlistFinalCTA/OlistFinalCTA';
import OlistFooter from '../../components/custom/OlistFooter/OlistFooter';
import OlistProductSelector from '../../components/custom/OlistProductSelector/OlistProductSelector';
import OlistFeatureSplitList from '../../components/custom/OlistFeatureSplitList/OlistFeatureSplitList';

const ERPPage = () => {
  return (
    <div className="min-h-screen bg-[#f2f0e8] font-sans selection:bg-blue-200">
      <OlistHeader />
      
      {/* ERP Hero Section */}
      <section className="relative pt-40 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-[#0A4EE4]">
        <div className="container mx-auto px-4 max-w-7xl relative z-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-16">
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full md:w-1/2 text-left"
            >
              <div className="inline-block px-4 py-1.5 bg-blue-500/30 border border-blue-400/30 rounded-full text-blue-100 text-sm font-bold mb-6">
                SISTEMA ERP COMPLETO
              </div>
              <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-8">
                O ERP que centraliza sua gestão <br/> 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 via-blue-200 to-teal-300">e acelera suas vendas</span>
              </h1>
              <p className="text-xl text-blue-100 mb-10 leading-relaxed max-w-xl">
                Controle estoque, financeiro, fiscal e vendas multicanal em um único lugar. A solução definitiva para quem busca escala e governança.
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <button className="w-full sm:w-auto bg-white text-blue-600 px-10 py-5 rounded-full font-bold text-lg hover:bg-slate-50 transition-all hover:scale-105 shadow-2xl">
                  Teste 30 dias grátis
                </button>
                <button className="w-full sm:w-auto flex items-center justify-center gap-2 text-white px-8 font-bold text-lg hover:text-teal-300 transition-colors">
                  Apresentação estratégica <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, scale: 0.9, x: 30 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="w-full md:w-1/2 relative"
            >
              <div className="relative rounded-[3rem] overflow-hidden border-8 border-white/10 shadow-3xl bg-white/5 backdrop-blur-sm p-4">
                <img 
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200"
                  alt="Sistema ERP Mockup"
                  className="rounded-[2rem] w-full shadow-2xl"
                />
                {/* Decorative float elements */}
                <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl hidden lg:block">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600">
                      <CheckCircle2 className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-slate-400 uppercase">Estoque Sincronizado</p>
                      <p className="text-lg font-black text-slate-900">100% Atualizado</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        
        {/* Background decorations */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-blue-700/20 to-transparent pointer-events-none"></div>
      </section>

      {/* Product Selector Toggle */}
      <OlistProductSelector />

      {/* ERP Core Value Prop with Image Side-by-Side */}
      <OlistFeatureSplitList />

      {/* Feature Grid */}
      <OlistFeatureGrid />
      
      {/* Pricing Section */}
      <OlistPricing />
      
      {/* FAQ */}
      <OlistFAQ />
      
      <OlistFinalCTA />
      <OlistFooter />
    </div>
  );
};

export default ERPPage;

